function ScheduleItem(aSchedule) {
    "use strict";

    this.Id = aSchedule.Id;
    this.Name = aSchedule.Name;
    this.EntityId = aSchedule.EntityId;
    this.TargetTypeId = aSchedule.ScheduleType;
    switch (aSchedule.ScheduleType) {
        case 8:
        case 1:
            this.TargetTypeName = localizeText('cZone');
            break;
        case 10:
        case 2:
            this.TargetTypeName = 'BLUhome';
            break;
        case 7:
        case 3:
            this.TargetTypeName = 'BLUbox';
            break;
        case 6:
            this.TargetTypeName = localizeText('cEnrolleeAddress');
            break;
    }
    this.TargetName = '';
    this.ScheduleType = localizeText('cEnrolleeReoccurring'); // ticket 1427
    if (!aSchedule.IsRecurring) {
        this.ScheduleType = localizeText('cEnrolleeOverride');
    }

    this.StartTime = aSchedule.StartTime;
    this.EndTime = aSchedule.EndTime;

    this.StartTimeLocal = aSchedule.StartTimeLocal;
    this.EndTimeLocal = aSchedule.EndTimeLocal;

    this.StartTimeUTC = aSchedule.StartTimeUTC;
    this.EndTimeUTC = aSchedule.EndTimeUTC;
    this.StartDateUTC = aSchedule.StartDateUTC;
    this.EndDateUTC = aSchedule.EndDateUTC;

    this.IsSunday = aSchedule.IsSunday;
    this.IsMonday = aSchedule.IsMonday;
    this.IsTuesday = aSchedule.IsTuesday;
    this.IsWednesday = aSchedule.IsWednesday;
    this.IsThursday = aSchedule.IsThursday;
    this.IsFriday = aSchedule.IsFriday;
    this.IsSaturday = aSchedule.IsSaturday;
    this.IsEnabled = aSchedule.IsEnabled;
    this.IsReocurring = aSchedule.IsRecurring;
    this.ZoneScheduleType = aSchedule.ZoneScheduleType;
    this.EnrolleeId = aSchedule.EnrolleeId;
}
if (typeof exports !== 'undefined') {
    module.exports = ScheduleItem;
}